module.exports = __webpack_public_path__ + "static/nutrition_screen-b6c2d78f5150237826ea95d258b05023.png";